import { useTranslation } from 'react-i18next';

export default function WhySection() {
  const { t } = useTranslation();

  const cards = [
    {
      icon: 'ri-folder-open-line',
      titleKey: 'why_organized_title',
      descKey: 'why_organized_desc',
    },
    {
      icon: 'ri-book-open-line',
      titleKey: 'why_buying_title',
      descKey: 'why_buying_desc',
    },
    {
      icon: 'ri-scales-3-line',
      titleKey: 'why_compare_title',
      descKey: 'why_compare_desc',
    },
    {
      icon: 'ri-shield-check-line',
      titleKey: 'why_safety_title',
      descKey: 'why_safety_desc',
    },
  ];

  return (
    <section id="why" className="w-full bg-background-50 py-16 md:py-24">
      <div className="section-container">
        <div className="section-inner">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 font-heading">
              {t('why_title')}
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {cards.map((card) => (
              <div
                key={card.titleKey}
                className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-accent-300 transition-all"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                  <i className={`${card.icon} text-lg md:text-xl text-accent-600`} />
                </div>
                <h3 className="font-semibold text-foreground-950 mb-2">
                  {t(card.titleKey)}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t(card.descKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}